import notEnabledImage from 'assets/images/cms/ordering-not-enabled.png'
import { buildTranslate } from 'locales'
import CmsPage from 'scenes/Cms/components/CmsPage'

const t = buildTranslate('cms.content.menu_category.not_enabled_page')

const NotEnabledPage = () => {
  return (
    <CmsPage
      title={t('title')}
      description={t('description')}
      contactButtonTitle={t('contact_our_team')}
    >
      <img
        className="max-width-100 mb-l"
        src={notEnabledImage}
        alt={t('image_alt')}
      />
    </CmsPage>
  )
}

export default NotEnabledPage
